import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const SignUp = createAsyncThunk(
  "client/signup-Customer",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/users-auth/website-sign-up`,
        data,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        } 
      );
      // console.log("Signup API Response:", response);
      return response.data; // ✅ Return only the data
    } catch (error) {
      console.error("Full error object:", error);
      console.error("Error response data:", error.response?.data);
      console.error("Error response status:", error.response?.status);
      console.error("Error response headers:", error.response?.headers);
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
export const getCustomerByUserId = createAsyncThunk(
  "client/get-customer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/customers/api/v1/get-customer-userId`,
        data,

      );
      console.log("Customer Response:", response);
      return response.data; 
    } catch (error) {
      console.error("Full error object:", error);
      console.error("Error response data:", error.response?.data);
      console.error("Error response status:", error.response?.status);
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

